import React from 'react';
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Button,
} from 'reactstrap';
import PropTypes from 'prop-types';

const CustomSurveyPublicReportModal = ({ modal, onChange, verifyPassword }) => (
  <Modal isOpen={modal}>
    <ModalHeader>Business Survey Report Verification</ModalHeader>
    <ModalBody>
      <Row>
        <Col xs="9">
          <Input
            type="password"
            name="password"
            id="pubpwd"
            placeholder="Enter the password"
            onChange={onChange}
          />
        </Col>
        <Col xs="3">
          <Button
            onClick={verifyPassword}
            style={{ backgroundColor: '#cccccc' }}
            color=""
          >
            Submit
          </Button>
        </Col>
      </Row>
    </ModalBody>
  </Modal>
);

CustomSurveyPublicReportModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  verifyPassword: PropTypes.func.isRequired,
};

export default CustomSurveyPublicReportModal;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/reports/CustomSurveyPublicReportModal.js